/**
 * Backend API base URL.
 * Local default: http://localhost:4000
 * Production: set REACT_APP_API_URL on Netlify, or use api.slimfaast.com subdomain.
 */
function resolveApiBase() {
  const fromEnv = process.env.REACT_APP_API_URL || process.env.REACT_APP_SERVER_ADDRESS
  if (fromEnv) return String(fromEnv).replace(/\/$/, '')

  if (typeof window !== 'undefined') {
    const host = window.location.hostname
    if (
      host === 'slimfaast.com' ||
      host === 'www.slimfaast.com' ||
      host.endsWith('.slimfaast.com')
    ) {
      return 'https://api.slimfaast.com'
    }
  }

  return 'http://localhost:4000'
}

export const API_BASE = resolveApiBase()
